import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Product as ProductEmptyState } from '~/components/EmptyState'
import { useOptionalSeller } from '~/hooks/data/use-seller'
import { cn } from '~/utils/classnames'

interface ProductsPlaceholderProps extends React.HTMLAttributes<HTMLDivElement> {
  hasProductsInOtherTab?: boolean
  currentTab?: 'published' | 'unpublished'
}

export const ProductsPlaceholder = ({
  className,
  hasProductsInOtherTab = false,
  currentTab = 'published',
  ...props
}: ProductsPlaceholderProps) => {
  const seller = useOptionalSeller()
  const { t } = useTranslation()

  const { title, description } = useMemo(() => {
    if (hasProductsInOtherTab) {
      return {
        title: t('page.products.empty_state.title_with_other_tab', {
          currentTab: t(`noun.${currentTab}`).toLowerCase(),
        }),
        description: t('page.products.empty_state.description_with_other_tab', {
          currentTab: t(`noun.${currentTab}`).toLowerCase(),
          otherTab: t(
            `noun.${currentTab === 'published' ? 'unpublished' : 'published'}`
          ),
        }),
      }
    }
    return {
      title: t('page.products.empty_state.title'),
      description: t('page.products.empty_state.description'),
    }
  }, [hasProductsInOtherTab, currentTab, t])

  return (
    <section className={cn('py-28 text-center', className)} {...props}>
      <ProductEmptyState className="mx-auto" />
      <div className="mx-auto mt-8 text-sm font-medium">
        <h2 className="text-foreground">{title}</h2>
        {seller && <p className="text-foreground/64 mt-2">{description}</p>}
      </div>
    </section>
  )
}
